"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgGlobe(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.628 0 12 5.372 12 12s-5.372 12-12 12C5.373 24 0 18.628 0 12S5.373 0 12 0zM2.131 8.501l-.082.241A10.459 10.459 0 001.532 12c0 5.782 4.687 10.468 10.468 10.468l-.092-.001v-.965c.097-.695-.439-1.996-1.3-2.821a1.725 1.725 0 01-.539-1.246v-1.763c0-.64-.36-1.23-.946-1.54-.826-.437-2-1.049-2.805-1.437a8.308 8.308 0 01-1.82-1.197l-.045-.04a6.41 6.41 0 01-1.038-1.142c-.346-.485-.83-1.172-1.284-1.815zm9.884-6.97l1.082 1.036c.36.345.36.902 0 1.246l-.27.258-.593.57a.428.428 0 000 .622l.27.258c.179.172.179.451 0 .623l-.46.44a.47.47 0 01-.326.129h-.517a.47.47 0 00-.32.125l-.57.531a.427.427 0 00-.091.513l.896 1.717c.153.293-.07.637-.411.637h-.324a.471.471 0 01-.302-.107l-.533-.444a.952.952 0 00-.894-.17l-1.791.571a.661.661 0 00-.47.624c0 .25.147.477.38.589l.637.305c.54.26 1.137.394 1.742.394s1.298 1.503 1.84 1.762h3.836c.488 0 .955.185 1.3.516l.787.753c.329.315.514.743.514 1.188 0 .682-.284 1.335-.789 1.816-.224.213-.46.437-.65.62a1.304 1.304 0 00-.355.59c-.086.312-.157.627-.274.929l-.763 1.972c4.271-1.09 7.492-4.805 7.84-9.327l-.856-.188a1.44 1.44 0 01-.842-.521l-1.071-1.409c-.32-.42-.32-.97 0-1.39l1.167-1.535c.137-.18.325-.327.547-.424A10.465 10.465 0 0012 1.532l.015-.001zm-1.946.179a10.39 10.39 0 00-1.928.556l.597.287c.612.292 1.331-.133 1.331-.788z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgGlobe;
exports.default = _default;